<header class="header {{classCustomTela}}" #header (window:resize)="onResize()" [ngClass]="{'is-home': isHome}">
    <div class="content">
        <div class="container">
            <div class="row">
                <div class="col-md-2 col-5 center-flex">
                    <modulo [isHome]="isHome" posicao="logo"></modulo>   
                </div>
                <div class="col-md-8 col-1">
                    
                </div>
                <div class="col-md-2 content-actions col-6">
                    <lang-list></lang-list>
                </div>
            </div>
        </div>     
    </div>  
</header>   